import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { IApiResponse } from "../../../AbstractApiClient/IApiResponse";
import {
  TGetFinixInfoRequestSchema,
  TGetFinixInfoResponseSchema,
} from "./getFinixInfo.schema";

export const getFinixInfo = (axios: IAxiosInstance) => {
  return async (params: TGetFinixInfoRequestSchema) => {
    const response = await axios.noRetry.get<
      IApiResponse<TGetFinixInfoResponseSchema>
    >(`/api/business-cards/info`, { params });

    return response.data;
  };
};
